exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-evaluation-modal[data-v-497d3819] .ant-result {\n  padding: 20px 32px;\n}\n.create-evaluation-modal[data-v-497d3819] .ant-result-icon {\n  margin-bottom: 10px;\n}\n.create-evaluation-modal[data-v-497d3819] .ant-result-icon svg {\n  color: #1783e8 !important;\n}\n.create-evaluation-modal[data-v-497d3819] .ant-result-title {\n  font-size: 20px;\n  font-weight: bold;\n}\n.create-evaluation-modal[data-v-497d3819] .ant-result-subtitle {\n  margin-top: 10px;\n}\n", ""]);

// exports
